import Vue from 'vue';
import eventBus from '@/components/common/Astral/EventBus/eventBus'
import Vuelidate from 'vuelidate';
import PasswordRecoveryForm from '@/components/Login/passwordRecovery/passwordRecoveryForm';

Vue.use(Vuelidate);
eventBus();

new Vue({
  render: h => h(PasswordRecoveryForm),
}).$mount('#recovery-form-vue-container');